import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { Observable, tap } from 'rxjs';

import { CartographieService } from '../cartographie/cartographie.service';
import { Cartographie } from '../cartographie/models/cartographie.model';
import { CartographieStore } from '../cartographie/store/cartographie.store';

export const cartographieResolver: ResolveFn<Observable<Cartographie>> = (route) => {
  const cartographieService = inject(CartographieService);
  const cartographieStore = inject(CartographieStore);
  const slug = route.params['slugCarto'] as string;
  const fragments = !!slug ? slug.split('-') : [];
  const idCartographie = fragments.length ? fragments[0] : '';

  return cartographieService.findById(idCartographie).pipe(
    tap((cartographie) => {
      cartographieStore.selectionner(cartographie);
    }),
  );
};
